import { PersonDisplay } from "./PersonDisplay";

export default PersonDisplay;
